document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');
    const add = form.querySelector('[name="add"]');
    const update = () => {
      const option = select.options[select.selectedIndex];
      if (idInput) idInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (add) {
        add.disabled = option.dataset.available !== 'true';
        add.textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
      }
    };
    select.addEventListener('change', update);
    update();
  });
});
